import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "labeltitle" }
const _hoisted_2 = { class: "labeltitle" }
const _hoisted_3 = { class: "labeltitle" }
const _hoisted_4 = { class: "labeltitle" }
const _hoisted_5 = { class: "labeltitle" }
const _hoisted_6 = { class: "labeltitle" }
const _hoisted_7 = { class: "labeltitle" }
const _hoisted_8 = { class: "labeltitle" }
const _hoisted_9 = { class: "labeltitle" }
const _hoisted_10 = { class: "labeltitle" }

import { onMounted, ref } from "vue";
import { useStore } from 'vuex';


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersFilter',
  props: ['selectedUser'],
  emits: ['close'],
  setup(__props, { emit: emits }) {

const props = __props;



const store = useStore();

var filter = ref({
    username: "",
    referring: "",
    institution: "",
    description: "",
    modality: ""
});

function closeCancel() {
    emits('close');
}

async function closeOk() {
    console.log("closeOk", filter.value);
    const result = await store.dispatch('HTTPPut', {url: 'userfilter/', id: filter.value.username, object: filter.value });
    alert(result);
    emits('close');
}

onMounted(async () => {
    const results = await store.dispatch('HTTPGet', {url: 'userfilter/'+props.selectedUser.UserName });
    if(results.length>0){
        filter.value = results[0];
    } else {
        filter.value.username = props.selectedUser.UserName;
    }
})

return (_ctx: any,_cache: any) => {
  const _component_modal_dialog = _resolveComponent("modal-dialog")!

  return (_openBlock(), _createBlock(_component_modal_dialog, {
    onCloseCancel: closeCancel,
    onCloseOk: closeOk,
    title: "User Filter",
    okBtn: "Accept",
    cnlBtn: "Cancel"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("UserEdit.UserName")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(filter).username) = $event)),
          style: {"width":"85%"},
          readonly: ""
        }, null, 512), [
          [_vModelText, _unref(filter).username]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("Study.ReferringPhysician")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(filter).referring) = $event)),
          style: {"width":"85%"}
        }, null, 512), [
          [_vModelText, _unref(filter).referring]
        ])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("Study.Institution")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(filter).institution) = $event)),
          style: {"width":"85%"}
        }, null, 512), [
          [_vModelText, _unref(filter).institution]
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t("Study.Description")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(filter).description) = $event)),
          style: {"width":"85%"}
        }, null, 512), [
          [_vModelText, _unref(filter).description]
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("Study.Modality")), 1),
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(filter).modality) = $event)),
          style: {"width":"85%"}
        }, null, 512), [
          [_vModelText, _unref(filter).modality]
        ])
      ])
    ]),
    _: 1
  }))
}
}

})